export const TYPE_DEFAULT = 'DEFAULT';
export const TYPE_EXTERNAL = 'EXTERNAL';
export const TYPE_FAVORITES = 'FAVORITES';

export const TYPE_ENUMS = [TYPE_DEFAULT, TYPE_EXTERNAL, TYPE_FAVORITES];
